import React from "react";
import styles from "./option-row.module.scss";
import cn from "../../../../../Utils/class-names.utils";

interface IOptionRowProps {
  label?: string;
  children: React.ReactNode;
  className?: string;
}

const OptionRow = ({ label, children, className }: IOptionRowProps) => {
  return (
    <div className={cn(styles.optionContainer, className)}>
      {label && (
        <h3 className={styles.optionLabel}>
          {label}
        </h3>
      )}
      {children}
    </div>
  );
};

export default OptionRow;

